/**
 * Utility: isExtranetHostname
 *
 * Detects whether the current browser session is running
 * on an Extranet subdomain. Supports multiple prefix patterns:
 *
 * - Local:      extranet.localhost
 *               extranet-membership.localhost
 * - Staging:    extranet-membership.omnihotelier.net
 * - Production: extranet.mymembership.id
 *
 * This is the single source of truth for extranet detection.
 * Always import from here instead of repeating the check inline.
 */

/**
 * Returns true if the current hostname matches any known extranet pattern.
 * @returns {boolean}
 */
export function isExtranetHostname() {
    const hostname = window.location.hostname;
    return (
        hostname.startsWith('extranet.') ||
        hostname.startsWith('extranet-membership.')
    );
}

export default isExtranetHostname;
